module.exports = __webpack_public_path__ + "img/gys-icon-1.fb8ea38c.png";